import { useEffect } from "react";
import "./TermsConditionsStyle.css"; // Reusing the same styles

const CancellationPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page-container">
      <h1 className="legal-heading">Cancellation Policy</h1>
      <div className="legal-content">
        <div className="legal-section">
          <h2>1. Order Cancellation Windows</h2>
          <p>
            You can cancel your order depending on its current status:
          </p>
          
          <table className="legal-table">
            <thead>
              <tr>
                <th>Order Status</th>
                <th>Cancellation</th>
                <th>Refund</th>
                <th>Processing Time</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Order Placed</td>
                <td>✅ Allowed</td>
                <td>100% refund</td>
                <td>Immediate</td>
              </tr>
              <tr>
                <td>Payment Processing</td>
                <td>✅ Allowed</td>
                <td>100% refund</td>
                <td>1-2 hours</td>
              </tr>
              <tr>
                <td>Order Processing</td>
                <td>⚠️ Limited</td>
                <td>95% refund*</td>
                <td>2-4 hours</td>
              </tr>
              <tr>
                <td>Shipped</td>
                <td>❌ Not allowed</td>
                <td>Return required</td>
                <td>Follow return policy</td>
              </tr>
            </tbody>
          </table>
          
          <p><em>*5% processing fee may apply during order processing stage</em></p>
        </div>

        <div className="legal-section">
          <h2>2. How to Cancel Your Order</h2>
          
          <h3>Self-Service Cancellation</h3>
          <p>For orders in "Order Placed" status:</p>
          <ol style={{paddingLeft: "1.5rem"}}>
            <li>Log into your Minute account</li>
            <li>Go to "My Orders" section</li>
            <li>Find your order and click "Cancel Order"</li>
            <li>Select cancellation reason</li>
            <li>Confirm cancellation</li>
          </ol>

          <h3>Customer Service Cancellation</h3>
          <p>For orders being processed or requiring assistance:</p>
          <ul>
            <li>Email: orders@minute.com with order number</li>
            <li>Phone: +91-XXX-XXX-XXXX</li>
            <li>Live Chat: Available on our website</li>
            <li>Include: Order number, reason for cancellation</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. Cancellation Reasons</h2>
          <p>
            Common reasons for order cancellation include:
          </p>
          <ul>
            <li>Changed mind about purchase</li>
            <li>Found better price elsewhere</li>
            <li>Ordered wrong item/size</li>
            <li>No longer need the item</li>
            <li>Financial reasons</li>
            <li>Delivery address issues</li>
          </ul>
          <div className="policy-highlight">
            <p>Providing cancellation reason helps us improve our service.</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>4. Refund Processing for Cancellations</h2>
          
          <h3>Immediate Cancellations (Order Placed)</h3>
          <p>
            For orders cancelled before processing begins:
          </p>
          <ul>
            <li>Automatic cancellation confirmation</li>
            <li>No charges applied to payment method</li>
            <li>Authorization holds released within 24-48 hours</li>
          </ul>

          <h3>Payment Processed Cancellations</h3>
          <p>
            For orders where payment has been processed:
          </p>
          <ul>
            <li>Refund initiated within 2-4 hours of cancellation approval</li>
            <li>Credit card refunds: 3-7 business days</li>
            <li>PayPal refunds: 1-3 business days</li>
            <li>Bank transfer refunds: 5-10 business days</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>5. Partial Cancellations</h2>
          <p>
            For orders with multiple items, you may be able to cancel individual items:
          </p>
          <ul>
            <li>Available only before order processing begins</li>
            <li>Remaining items will ship as planned</li>
            <li>Shipping costs adjusted proportionally</li>
            <li>Minimum order requirements may affect shipping discounts</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>6. Custom/Personalized Orders</h2>
          <p>
            Special rules apply to custom or personalized watches:
          </p>
          <ul>
            <li><strong>Before customization starts:</strong> Full cancellation allowed</li>
            <li><strong>During customization:</strong> 50% cancellation fee</li>
            <li><strong>After customization:</strong> No cancellation allowed</li>
          </ul>
          <div className="policy-highlight">
            <p>We'll notify you before starting any customization work.</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>7. Pre-Order Cancellations</h2>
          <p>
            For pre-ordered items with future release dates:
          </p>
          <ul>
            <li>Cancellation allowed up to 48 hours before expected ship date</li>
            <li>Full refund for cancellations within allowed timeframe</li>
            <li>Email reminders sent 7 days before ship date</li>
            <li>Option to delay shipment instead of cancelling</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>8. Bulk Order Cancellations</h2>
          <p>
            For orders with 5+ watches or orders over $2,000:
          </p>
          <ul>
            <li>Contact customer service directly</li>
            <li>May require manager approval for cancellation</li>
            <li>Processing fees may apply based on order stage</li>
            <li>Response time: Within 4-6 business hours</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>9. Payment Method Specific Policies</h2>
          
          <h3>Credit/Debit Cards</h3>
          <ul>
            <li>Authorization holds released automatically</li>
            <li>Processed payments refunded to original card</li>
            <li>Refund timeline depends on issuing bank</li>
          </ul>

          <h3>PayPal</h3>
          <ul>
            <li>Instant cancellation for pending payments</li>
            <li>Completed payments refunded to PayPal balance</li>
            <li>Fastest refund method available</li>
          </ul>

          <h3>Bank Transfers</h3>
          <ul>
            <li>Manual processing required</li>
            <li>May take 5-10 business days</li>
            <li>Original bank details required for refund</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>10. Merchant-Initiated Cancellations</h2>
          <p>
            We may cancel orders in the following situations:
          </p>
          <ul>
            <li>Payment authorization fails</li>
            <li>Item becomes unavailable after order placement</li>
            <li>Pricing errors or system glitches</li>
            <li>Shipping restrictions to delivery address</li>
            <li>Suspected fraudulent activity</li>
          </ul>
          <p>
            In such cases, you'll be notified immediately and receive a full refund 
            within 2-3 business days.
          </p>
        </div>

        <div className="legal-section">
          <h2>11. Cancellation Impact on Promotions</h2>
          <p>
            When cancelling orders with promotions:
          </p>
          <ul>
            <li>Cancelled items lose promotional pricing</li>
            <li>Remaining items may lose volume discounts</li>
            <li>Free shipping thresholds recalculated</li>
            <li>Coupon codes become available for reuse</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>12. Expedited Cancellation Service</h2>
          <p>
            For urgent cancellations (premium service):
          </p>
          <ul>
            <li>Available for orders under $1,000</li>
            <li>Guaranteed processing within 1 hour</li>
            <li>$10 fee for expedited service</li>
            <li>Available during business hours only</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>13. International Order Cancellations</h2>
          <p>
            Additional considerations for international orders:
          </p>
          <ul>
            <li>Currency conversion rates may affect refund amounts</li>
            <li>International transaction fees may apply</li>
            <li>Extended processing time for cross-border refunds</li>
            <li>Local bank fees are customer's responsibility</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>14. Contact Information</h2>
          <p>
            For cancellation assistance and questions:
          </p>
          <p>
            <strong>Primary Contact:</strong><br/>
            Email: orders@minute.com<br/>
            Subject Line: "URGENT - Order Cancellation [Order Number]"
          </p>
          <p>
            <strong>Phone Support:</strong><br/>
            +91-XXX-XXX-XXXX<br/>
            Hours: Monday-Saturday, 9 AM - 8 PM IST
          </p>
          <p>
            <strong>Live Chat:</strong><br/>
            Available on website during business hours<br/>
            Average response time: Under 5 minutes
          </p>
        </div>

        <div className="legal-footer">
          <p><strong>Last Updated:</strong> January 2025</p>
        </div>
      </div>
    </div>
  );
};

export { CancellationPolicy };